import React, { FC } from "react";
import Icon from "@ht/shared/fonts/deos-pis/arsi";
interface IProps {
  name?: string
}
const DummyCard: FC<IProps> = ({ name }) => {
  return (
    <div
      className="h-[100%] min-h-[120px] bg-gray-200 rounded-lg flex flex-wrap justify-center items-center gap-[10px]">
      <Icon className="w-[36px] h-[36px]"></Icon>
      <span className="font-bold text-md">{name === "videolocal" ? "You" : name}</span>
    </div>
  );
}

export default DummyCard;
